import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr } from "../../Helper/ToastMessage";

export const GardenCompletedWorkReportTableDataAPI = createAsyncThunk("GardenCompletedWorkReportTableData", async ({ data }) => {
    const {
        UserID,
        token,
        M_ProjectID,
        FromDate,
        M_WardID,
        ToDate,
        M_WorkTypeID,
        M_WorkID,
        Flag,
        M_AssetTypeID,
        M_AssetID,
        // handleGetPDFUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_RM_T_UploadAssignWorkCompletedWorkSelect?M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WorkTypeID=${M_WorkTypeID ? M_WorkTypeID : '0'}&M_WorkID=${M_WorkID ? M_WorkID : '0'}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : 0}&M_AssetID=${M_AssetID ? M_AssetID : 0}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&Flag=${Flag}&UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                // handleGetPDFUrl(result.url)
                return result.data
            } else {
                toastErrorr(result.message)
                return result
            }
        })
})

const GardenCompletedWorkReportTableDataSlice = createSlice({
    name: "GardenCompletedWorkReportTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GardenCompletedWorkReportTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GardenCompletedWorkReportTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(GardenCompletedWorkReportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const GardenCompletedWorkReportTableDataReducer = GardenCompletedWorkReportTableDataSlice.reducer

export const GardenCompletedWorkPDFReportTableDataAPI = createAsyncThunk("GardenCompletedWorkPDFReportTableData", async ({ data }) => {
    const {
        UserID,
        token,
        M_ProjectID,
        FromDate,
        M_WardID,
        ToDate,
        M_WorkTypeID,
        M_WorkID,
        Flag,
        M_AssetTypeID,
        M_AssetID,
        handleGetPDFUrl,
        setPDFLoader
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    setPDFLoader(true)
    return fetch(`${BaseUrl}/APKDashboard/Get_RM_T_UploadAssignWorkCompletedWorkSelect?M_ProjectID=${M_ProjectID ? M_ProjectID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WorkTypeID=${M_WorkTypeID ? M_WorkTypeID : '0'}&M_WorkID=${M_WorkID ? M_WorkID : '0'}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : 0}&M_AssetID=${M_AssetID ? M_AssetID : 0}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&Flag=${Flag}&UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.url) {
                setPDFLoader(false)
                handleGetPDFUrl(result.url)
                return result.url
            } else {
                setPDFLoader(false)
                toastErrorr(result.message)
                return result
            }
        })
})

const GardenCompletedWorkPDFReportTableDataSlice = createSlice({
    name: "GardenCompletedWorkPDFReportTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GardenCompletedWorkPDFReportTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GardenCompletedWorkPDFReportTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(GardenCompletedWorkPDFReportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const GardenCompletedWorkPDFReportTableDataReducer = GardenCompletedWorkPDFReportTableDataSlice.reducer